import { useMutation, useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

export const useProductCampaignTracker = (productId: any, type?: any) => {
  const {
    data: response,
    isFetching,
    refetch
  } = useQuery({
    queryKey: ['campaignTracker', productId, type],
    queryFn: () => productService.loadCampaignTracker(productId, type),
    enabled: !!productId
  });

  return {
    trackerData: response?.data,
    isFetching,
    refetch
  };
};

export const useCreateOrUpdateCampaignTracker = () => {
  return useMutation({
    mutationFn: ({ tracker, id }: { tracker: any; id?: any }) =>
      productService.createOrUpdateCampaignTracker(tracker, id)
  });
};

export const useDeleteCampaignTracker = () => {
  return useMutation({
    mutationFn: ({ id, type }: { id: any; type: string }) => productService.deleteCampaignTracker(id, type)
  });
};
